<mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
        <mat-panel-title>
            {{ 'billing.CRM.byMonthTable.title' | translate }}
        </mat-panel-title>

        <mat-panel-description>
            {{ 'billing.CRM.byMonthTable.description' | translate }}
        </mat-panel-description>
    </mat-expansion-panel-header>

    <section class="tableContainer">

        <section class="exportBtnContainer">
            <button mat-raised-button color="accent" (click)="onExportExcel()">
                <mat-icon aria-label="File">insert_drive_file</mat-icon>
                Exporter en excel
            </button>
        </section>

        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="month">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'billing.CRM.byMonthTable.list.month' | translate }}
                </th>
                <td mat-cell *matCellDef="let statistic"> {{statistic.month}} </td>
            </ng-container>

            <ng-container matColumnDef="numberOfOrders">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'billing.CRM.byMonthTable.list.numberOfOrders' | translate }}
                </th>
                <td mat-cell *matCellDef="let statistic"> {{statistic.numberOfOrders | number:'1.0-0'}} </td>
            </ng-container>

            <ng-container matColumnDef="numberOfExtraOrders">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'billing.CRM.byMonthTable.list.numberOfExtraOrders' | translate }}
                </th>
                <td mat-cell *matCellDef="let statistic"> {{statistic.numberOfExtraOrders | number:'1.0-0'}} </td>
            </ng-container>

            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'billing.CRM.byMonthTable.list.price' | translate }}
                </th>
                <td mat-cell *matCellDef="let statistic"> {{statistic.price | number:'1.2-2'}} €</td>
            </ng-container>

            <ng-container matColumnDef="extraPrice">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'billing.CRM.byMonthTable.list.extraPrice' | translate }}
                </th>
                <td mat-cell *matCellDef="let statistic"> {{statistic.extraPrice | number:'1.2-2'}} €</td>
            </ng-container>

            <ng-container matColumnDef="totalPrice">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'billing.CRM.byMonthTable.list.totalPrice' | translate }}
                </th>
                <td mat-cell *matCellDef="let statistic"> {{statistic.totalPrice | number:'1.2-2'}} €</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10]" aria-label="Select page of users"></mat-paginator>
    </section>
</mat-expansion-panel>